/*global jQuery, shop, window */
(function($) {

  'use strict';

  


  /*SHOP*/

  $('.toggle-cart-widget').on('click', function(){
    console.log('toggle-cart-widget');
    $('.cart-widget').fadeToggle()

    $.ajax({url: '/ajax/cart-functions.php?action=get-cart-widget-content', success: function(result){
      $('.cart-widget-content').html(result);
    }});
  });

  $('.cart-widget').mouseleave(function(){
    $('.cart-widget').fadeToggle()
  })



  const getModalActionButton = (button) => `<button type="button" class="btn btn-default" id="modal-action-${button.id}"> ${button.text} </button>`;

  const getModalDismissButton = (button) => `<button type="button" class="btn btn-default" data-dismiss="modal">  ${button.text} </button>`;

  const addModalButton = ($container, button) => {
    const $button = $(button.dismiss || !button.action ?
        getModalDismissButton(button) : getModalActionButton(button));
    $container.append($button);
    if (button.action) {
      $button.on('click', button.action);
    }
  };

  const modalStandard = (template, buttons) => {
    buttons = buttons || [{text: 'Chiudi'}];
    showModal(template, buttons, false);
  };

  const showModal = function(message, buttons) {
    const $modal = $('.modal');
    const $modalFooter = $modal.find('.modal-footer');

    $('.modal-body').hide().html(message).show();

    if (!$modal.hasClass('in')) {
      $modal.modal('show');
    }

    $modalFooter.html('');

    if (buttons && buttons.length > 0) {
      $.each(buttons, function(index, button) {
        addModalButton($modalFooter, button);
      });
    }

    return $modal;
  };

  const rules = {
    email: {
      required: true,
      email: true
    },
    numero_telefono: {
      required: true
    },
    password: {
      required: true,
      minlength: 6
    },
    password_check: {
      equalTo: '#password'
    },
    name: {
      required: true
    },
    lastname: {
      required: true
    },
    check_privacy: {
      required: true
    },
    check_condizioni: {
      required: true
    }
  };
  const messages = {
    email: {
      required: 'inserire la mail',
      email: 'inserire una mail corretta'
    },
    password: {
      required: 'inserire la password',
      minlength: 'la password deve avere almeno {0} caratteri'
    },
    password_check: {
      equalTo: 'le password inserite non corrispondono'
    },
    name: {
      required: 'inserire il nome'
    },
    numero_telefono: {
      required: 'inserire un recapito telefonico'
    },
    lastname: {
      required: 'inserire il cognome'
    },
    check_privacy: {
      required: 'consenso sulla privacy obbligatorio'
    },
    check_condizioni: {
      required: 'consenso sulle condizioni di vendita obbligatorio'
    }
  };
  const $popup = $('.popup');
  const validatePopup = (submitHandler) => {
    
    const $form = $popup.find('.popup-form');
    const $errorsContainer = $popup.find('.popup-errors');
    const settings = {
      errorPlacement: (error) => {
        const $error = $(error);
        $(`#${$error.attr('id')}`).remove();
        $errorsContainer.append(error);
        if ($errorsContainer.children().length) {
          $errorsContainer.show();
        }
      },
      success: (error) => {
        const $error = $(error);
        $(`#${$error.attr('id')}`).remove();
        if (!$errorsContainer.children().length) {
          $errorsContainer.hide();
        }
      },
      messages,
      rules
    };
    if (submitHandler) {
      settings.submitHandler = submitHandler;
    }

    $form.on('submit', (event) => event.preventDefault()).validate(settings);
  };

  const showAjaxModal = (url, buttons, data, callback) => {
    data = data || {};
    if (shop.language) {
      data.language = shop.language;
    }
    $.ajax({url, data}).done((template) => {
      const $modal = showModal(template, buttons);
      if (callback) {
        callback($modal);
      }
    });
  };

  const modalError = (error, buttons, callback) => {
    if (!error) {
      error = 'Si è verificato un errore.';
    }
    buttons = buttons || [{text: 'Chiudi'}];
    showAjaxModal(`/templates/popup-error.page.php?message=${error}`,
      buttons, false, callback);
  };

  const modalSuccess = (message, buttons, callback) => {
    if (!message) {
      message = 'Operazione completata con successo.';
    }
    buttons = buttons || [{text: 'Chiudi'}];
    showAjaxModal(`/templates/popup-success.page.php?message=${message}`,
      buttons, false, callback);
  };

  const modalConfirm = (message, buttons) => {
    if (!message) {
      message = 'Confermi l\'operazione?';
    }
    showAjaxModal(`/templates/popup-confirm.page.php?message=${message}`,
      buttons);
  };

  const addToCartSuccess = (message) => {
    console.log(shop.cartURL);
    if (!message) {
      message = 'Il prodotto è stato aggiunto al carrello.';
    }
    const buttons = [
      {
        text: 'Vai al carrello',
        action: () => window.location.href = shop.cartURL
      },
      {text: 'Continua gli acquisti',
        action: () => location.reload()}
    ];
    modalSuccess(message, buttons);
  };

  const addToCart = (products, language) => $.ajax({
    url: '/ajax/cart-add-product.php',
    type: 'POST',
    dataType: 'json',
    data: {products, language}
  });

  const removeFromCart = (products, quantity, language) =>
    $.ajax({
      url: '/ajax/cart-remove-product.php',
      type: 'POST',
      dataType: 'json',
      data: {products, quantity, language}
    });

  const goToCart = () => location.href = shop.cartURL;

  const addToCartModal = (products, language) => {
    addToCart(products, language).done((result) => {
      if (result.error) {
        modalError(result.errorMessage);
        return;
      }
      addToCartSuccess();
    })
    .fail(modalError);
  };

  

  const getPopupContent = (title, message, icon, type) =>
    `<div class="popup-step"><span class="glyphicon glyphicon-${icon} popup-icon popup-icon-${type}"></span><h3>${title}</h3><p>${message}</p></div>`;

  const getResultMessage = (result) => {
    const message = newsletterSetup.texts.newsletterErrors[parseInt(result)];
    if (message) {
      return message;
    }
    return newsletterSetup.texts.newsletterErrors.generic;
  };


  let signUp;
  let signIn;
  let resetPassword;
  let confirmRegistration;

  const getPopupUrl = (name) =>
    `/controllers/${name}.php?language=${shop.language}`;

  const url = location.href.match(/\/$/) ?
    location.href.substring(0, location.href.length - 1) : location.href;
  const currentPage = url.match((/[^\/]+$/))[0];

  signUp = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-register'), [
      {text: 'Torna alla Login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  resetPassword = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-reset-password'), [
      /*{text: 'Registrati', action: () => signUp()},*/
      {text: 'Torna alla Login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  signIn = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-login'), [
      {text: 'Recupera password', action: () => resetPassword(data)},
      /*{text: 'Registrati', action: () => signUp()},*/
      {text: 'Chiudi'}
    ], data, callback);
  };

  confirmRegistration = (code, data, callback) => {
    showAjaxModal(`${getPopupUrl('popup-confirm-registration')}&code=${code}`, [
      {text: 'Vai alla login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  const newPassword = (code, data, callback) => {
    showAjaxModal(`${getPopupUrl('popup-new-password')}&code=${code}`, [
      {text: 'Vai alla login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  $('.account-login').on('click', () => signIn({redirectUrl: currentPage}));

  

  $('.shop-buy').on('click', function() {
    const product = {
      product: $(this).data('product'),
      quantity: $(this).data('quantity') || 1,
      priceList: $(this).data('priceList')
    };
    const language = shop.language;
    addToCart([product], language)
      .done((result) => {
        if (result.error) {
          modalError();
          return;
        }
        goToCart();
      })
      .fail(modalError);
  });

  $('.shop-add-to-cart').on('click', function() {
    console.log('shop-add-to-cart');
    const product = {
      product: $(this).data('product'),
      quantity: $(this).data('quantity') || 1,
      priceList: $(this).data('priceList')
    };
    const language = shop.language;
    addToCartModal([product], language);
  });

  window.shop = window.shop || {};
  $.extend(window.shop, {
    showAjaxModal,
    validatePopup,
    confirmRegistration,
    newPassword,
    addToCartModal,
    addToCart,
    removeFromCart,
    modalStandard,
    modalError,
    modalSuccess,
    modalConfirm,
    signIn,
    signUp,
    currentPage,
    goToCart
  });



  $(function() {


    $("#breadcrumbs").rcrumbs({windowResize: true});

    

    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };

    var distance = $('#menu').height(),
    $window = $(window);

    var contentTop = $('#menu_interne').height() ;
    $('.content_interne').css('margin-top', contentTop + 'px');
    $('#menu_interne').css('position', 'fixed');

    $window.resize(function() {
      var contentTop = $('#menu_interne').height() ;
      $('.content_interne').css('margin-top', contentTop + 'px');
    });
    

    function detectmob() { 
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     || (navigator.userAgent.match(/Mac/i) && "ontouchstart" in document.documentElement)
     ){
        return true;
      }
     else {
        return false;
      }
    }

    //alert(navigator.userAgent);
    //alert(navigator.platform);

    if (detectmob()){
      $('.nome_prodotto_intro').css('display', 'block').css('height', '30%');
    }




    $window.scroll(function() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      } else {
        if ($window.scrollTop() >= distance) {
          $('#menu2').fadeIn();
        } else {
          $('#menu2').hide();
        }
      }
    });

  });

}(jQuery));